import {createContext} from "react";
import {unimplementedFunction} from "../common/Utils";

export const SetReadyContext = createContext(unimplementedFunction);
